import styled from "styled-components";

export const HeaderStyled = styled.header`

  background-color: #121216;
  min-height: 55px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  position: fixed;
  z-index: 100;
  width: 100%;

  nav{
    .menuBurger{
      display: none;
      background-color: transparent;
      border: none;
    }
    .css-0 {
      background-color: #0077FF;
      border-radius: 10px;
      padding: 10px;
      width: 50%;
    }
    .css-0 > .css-sjt5nk {
      display: flex;
      flex-direction: column;
      text-decoration: none;
      padding: 20px;
      border-radius: 5px;
      background-color: #121216;
      
    }

    .css-0 > .css-sjt5nk > a {
      margin: 0 0 20px 0;
      color: #FFFFFF;
      text-decoration: none;
      -webkit-transition: 0.3s ease-out;
      -moz-transition: 0.3s ease-out;
      -o-transition: 0.3s ease-out;
      transition: 0.3s ease-out;
    }

    .css-0 > .css-sjt5nk > a:hover {
      margin-left: 5px;
      color: #0077FF;
      -webkit-transition: 0.3s ease-out;
      -moz-transition: 0.3s ease-out;
      -o-transition: 0.3s ease-out;
      transition: 0.3s ease-out;
    }

    .divA{
      display: flex;
      flex-direction: row;
      justify-content: space-evenly;
    }

    .divA > .aIcon {
      font-size: 32px;
      -webkit-transition: 0.3s ease-out;
      -moz-transition: 0.3s ease-out;
      -o-transition: 0.3s ease-out;
      transition: 0.3s ease-out;
    }

    .divA > .aIcon:hover {
      color: #00008e;
      -webkit-transition: 0.3s ease-out;
      -moz-transition: 0.3s ease-out;
      -o-transition: 0.3s ease-out;
      transition: 0.3s ease-out;
    }


  }

.logo {
  color: white;
  text-decoration: none;
  outline: none;
  font-size: 1.125rem;
  white-space: nowrap;
  font-weight: 700;
}
.logo:hover {
  color: white;
}
.logo span {
  color: #0077FF;
}

ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

.menu {
  display: flex;
}

.menu li {
  margin: 0 6px;
}

.menu a {
  text-decoration: none;
  font-weight: 700;
  font-size: 1.125rem;
  margin: 0 8px;
  color: white;
  transition: 0.3s !important;
  display: block;
}

.menu a:hover {
  transition: 0.3s;
  color: #0077FF;
}

.menu a::after {
  content: "";
  position: absolute;
  left: 0;
  top: 30px;
  height: 3px;
  background-color: #0077FF;
  width: 0;
  transition: 0.3s;
}

.menu a:hover::after {
  content: "";
  transition: 0.3s;
  width: 100%;
}

@media (max-width: 1000px) {

    justify-content: space-between;
    padding: 0 14px;

  .linkNav{
    .css-p7mkev{
      display: flex;
    }
  }


  .menu {
    display: block;
    visibility: hidden;
    overflow: hidden;
    text-align: center;
    line-height: 100px;
    background-color: #121216f2;
    position: absolute;
    width: 100%;
    height: 0;
    transition: ease 0.8s;
    top: 55px;
    left: 0;
  }

  .menu a {
    margin: 0;
  }

  .menu a:hover {
    background-color: #202024a9;
  }

  .menu a:hover::after {
    width: 0;
  }

}


`